module.exports = __webpack_public_path__ + "img/portal-v5-min.c7c4e438.jpg";